import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { commissionSlabQueries } from '@/services/slabs/slabs.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useSlabDelete = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation('deleteSlab', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: [...commissionSlabQueries.all()] });
      toast.success(res.message);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });

  return { mutateAsync: mutation.mutateAsync };
};
